export default {
  left_column: {
    title: 'Tarkista saldo',
    description:
      'Anna lahjakortin koodi tarkistaaksesi jäljellä olevan saldon. Koodi löytyy lahjakortin PDF-tiedostosta.',
  },
  title: 'Tarkista lahjakortin saldo',
  subtitle: 'Anna lahjakortin koodi tarkistaaksesi sen nykyisen saldon',
  error: {
    title: 'Lahjakorttia ei löytynyt!',
    description: 'Anna kelvollinen lahjakortin koodi.',
  },
  gift_card: {
    title: 'Lahjakortti löytyi!',
    balance: 'Saldo',
    value: 'Arvo',
    expires_at: 'Vanhenee',
  },
  form: {
    code: {
      label: 'Lahjakortin koodi',
    },
  },
  buttons: {
    check_balance: 'Tarkista saldo',
  },
};
